<template>
	<div>
		<div class="first_line">
			<div class="left_warp">
				加盟商
				<el-input size="small" style="text-align: center" class="jul" placeholder="请输入加盟商" v-model="list.name"
					clearable></el-input>
				<!-- <el-select class="jul" size="small" v-model="list.name" placeholder="请选择" clearable>
				<el-option
					v-for="item in franchiseesStore"
					:key="item.name"
					:label="item.name"
					:value="item.name"></el-option>
			</el-select> -->
				加盟门店
				<el-select v-model="list.storeId" clearable @change="list.name = '',list.phone = ''" size="small">
					<el-option-group label="营业门店" class="store">
						<el-option v-for="item in stores" :key="item.id" :label="item.title" :value="item.id">
						</el-option>
					</el-option-group>
					<el-option-group label="结业门店">
						<el-option v-for="item in storesEnd" :key="item.id" :label="item.title" :value="item.id">
						</el-option>
					</el-option-group>
				</el-select>
				<!-- 加盟门店状态
			<el-select class="jul" size="small" v-model="timeVal" placeholder="请选择">
				<el-option
					v-for="item in friendslist"
					:key="item.value"
					:label="item.label"
					:value="item.value"></el-option>
			</el-select> -->
				手机号
				<el-input size="small" style="text-align: center" class="jul" placeholder="请输入手机号" v-model="list.phone"
					clearable></el-input>
				创建时间
				<el-date-picker v-model="createTime" type="daterange" size="small" style="width: 250px;"
					value-format="yyyy-MM-dd" range-separator="至">
				</el-date-picker>
				<el-button class="jul" type="primary" size="small" @click="getlist()">筛选</el-button>
				<el-button type="primary" size="small" @click="addfriend">新建加盟商</el-button>
				<el-button type="primary" size="small" @click="expor">导出</el-button>
			</div>
		</div>
		<div>
			<el-table :cell-style="{'text-align':'center'}"
				:header-cell-style="{background:'#F2F2F4','text-align':'center'}" ref="multipleTable" :data="tableData"
				tooltip-effect="dark" style="width: 100%" @selection-change="handleSelectionChange">
				<el-table-column prop="name" label="加盟商名称"></el-table-column>
				<el-table-column prop="phone" label="联系方式"></el-table-column>
				<el-table-column prop="storeName" label="加盟门店">
					<template slot-scope="scope">
						{{scope.row.storeName?scope.row.storeName:"/"}}
					</template>
				</el-table-column>
				<el-table-column prop="createTime" label="创建时间"></el-table-column>
				<el-table-column prop="storeConfigure" label="加盟状态">
					<template slot-scope="scope" v-if="scope.row.storeName">
						{{scope.row.storeConfigure | franchiseesStatus}}
					</template>
					<template slot-scope="scope" v-else>
						{{}}
					</template>
				</el-table-column>
				<el-table-column label="合同期限">
					<template slot-scope="scope" v-if="scope.row.storeName">
						{{scope.row.franchiseesStartTime}}至{{scope.row.franchiseesEndTime}}
					</template>
					<template slot-scope="scope" v-else>
						{{}}
					</template>
				</el-table-column>
				<el-table-column width="130" label="操作">
					<template slot-scope="scope">
						<div>
							<el-button type="text" @click="show(2,scope.row.id)">查看</el-button>
							<el-button type="text" @click="show(3,scope.row.id)">编辑</el-button>
						</div>
					</template>
				</el-table-column>
			</el-table>
		</div>
	</div>
</template>
<script>
	import {
		url
	} from '../../../utils/index.js'
	import {
		export2Excel
	} from '../../../common/js/util'
	export default {
		data() {
			return {
				url: url(),
				friendslist: [{
					value: "",
					label: "全部"
				}, {
					value: 0,
					label: "选址中"
				}, {
					value: 1,
					label: "装修中"
				}, {
					value: 2,
					label: "物资配送中"
				}, {
					value: 3,
					label: "确定营业"
				}, {
					value: 4,
					label: "正常营业"
				}],
				list: {
					title: "",
					name: "",
					startTime: '',
					endTime: '',
					storeConfigure: 1,
					friendslist: 0,
					franchiseesStoreId: '',
					storeId: '',
					phone: '',
				},
				createTime: [],
				tableData: [],
				franchiseesStore: [],
				storeIds: '', //查询的加盟门店
				storeIds1: '', //查询的加盟门店
				stores: [], //营业门店
				storesEnd: [], //全部门店
				// 开业时间
				times: "",
				// 选择门店
				timeVal: "",
				storeval: [{
					label: "全部店铺",
					value: 1,
				}, {
					label: "龙口西店",
					value: 2,
				}, {
					label: "五月花店",
					value: 3,
				}, ],
				storelist: [{
					label: "状态",
					value: 1,
				}, {
					label: "正常营业",
					value: 2,
				}, {
					label: "门店撤店",
					value: 3,
				}, {
					label: "即将开业",
					value: 4,
				}, {
					label: "门店调休",
					value: 5,
				}, ],
				columns: [{
					title: '加盟商',
					key: 'name'
				}, {
					title: '门店',
					key: 'storeName'
				}, {
					title: '营业执照号',
					key: 'businessNum'
				}, {
					title: '联系方式',
					key: 'phone'
				}, {
					title: '紧急联系方式',
					key: 'sosPhone'
				}, {
					title: '签约时间',
					key: 'signUp'
				}, {
					title: '是否缴纳备用金',
					key: 'isPayment'
				}, {
					title: '备用金',
					key: 'paymentNum'
				}, {
					title: '加盟金额',
					key: 'franchiseesFee'
				}, {
					title: '加盟起始时间',
					key: 'contractStart'
				}, {
					title: '加盟结束时间',
					key: 'contractEnd'
				}, {
					title: '加盟备注',
					key: 'joinComment'
				}, {
					title: '门店状态',
					key: 'storeConfigure'
				}, {
					title: '门店管理员电话',
					key: 'franchiseesStorePhone'
				}, {
					title: '开业时间',
					key: 'openStore'
				}, {
					title: '门店合同起始时间',
					key: 'franchiseesStartTime'
				}, {
					title: '门店合同结束时间',
					key: 'franchiseesEndTime'
				}, {
					title: '门店管理员姓名',
					key: 'franchiseesStoreName'
				}, {
					title: '门店登陆密码',
					key: 'franchiseesStorePassword'
				}],
				currentPage4: 4,
				multipleSelection: "",
			};
		},
		filters: {
			franchiseesStatus(val) {
				switch (val) {
					case 0:
						return "选址中";
					case 1:
						return "装修中";
					case 2:
						return "物资配送中";
					case 3:
						return "确定营业中";
					case 4:
						return "营业中";
					case 5:
						return "合约已到期";
					default:
						return "/";
				}
			}
		},
		mounted() {
			this.getFranchiseesStores();
			this.getStores();
			this.getlist()
		},
		methods: {
			show(a, id) {
				for (let i in this.tableData) {
					if (this.tableData[i].id == id) {
						this.$router.push({
							path: "newjoin",
							query: {
								demo: a,
								id: this.tableData[i].id
							}
						})
					}
				}
				// 　this.$router.push({ path: '/newjoin', query: { demo: i } })
			},
			expor() {
				var that = this
				var a = this.tableData
				for (var i = 0; i < a.length; i++) {
					if (a[i].isPayment == null || a[i].isPayment == "0") {
						a[i].isPayment = "否"
					} else if (a[i].isPayment == "1") {
						a[i].isPayment = "是"
					}
					if (a[i].storeConfigure == null) {
						a[i].storeConfigure = "/"
					} else if (a[i].storeConfigure == 0) {
						a[i].storeConfigure = "选址中"
					} else if (a[i].storeConfigure == 1) {
						a[i].storeConfigure = "装修中"
					} else if (a[i].storeConfigure == 2) {
						a[i].storeConfigure = "物资配送中"
					} else if (a[i].storeConfigure == 3) {
						a[i].storeConfigure = "确定营业中"
					} else if (a[i].storeConfigure == 4) {
						a[i].storeConfigure = "营业中"
					} else if (a[i].storeConfigure == 5) {
						a[i].storeConfigure = "合约已到期"
					}
				}
				export2Excel(this.columns, a)
				this.getlist()
			},
			async getlist() {
				await this.getStoreIds()
				console.log(this.storeIds) //查询出的加盟门店
				await this.getFranchiseesStore()
				// }else{
				// 	if(this.list.storeId|| this.list.startTime){
				// 		this.$http.get("store/getFranchiseesList"+this.list).then(function(res){
				// 		if(res.body.code=="200"){
				// 			this.tableData=[]
				// 			this.tableData = res.body.data
				// 			}
				// 		})
				// 	}
				// }
				// // for(let i in this.tableData){
				// 	if(this.tableData[i].schedule==0){this.tableData[i].schedule="选址中"}
				// 	if(this.tableData[i].schedule==1){this.tableData[i].schedule="装修中"}
				// 	if(this.tableData[i].schedule==2){this.tableData[i].schedule="物资配送中"}
				// 	if(this.tableData[i].schedule==3){this.tableData[i].schedule="确定营业"}
				// 	if(this.tableData[i].schedule==4){this.tableData[i].schedule="正常营业"}
				// }
				// }
			},
			getStoreIds() {
				return new Promise((resolve) => {
					if (this.createTime) {
						this.list.startTime = this.createTime[0]
						this.list.endTime = this.createTime[1]
					} else {
						delete this.list.startTime
						delete this.list.endTime
					}
					this.storeIds = ''
					if (this.list.storeId) {
						this.storeIds = this.list.storeId
						resolve()
					} else {
						this.$http.get("store/getFranchiseesList", {
							params: this.list
						}, {
							emulateJSON: true
						}).then(res => {
							if (res.body.code == '200') {
								var a = [];
								a = res.body.data
								if (a.length > 1) {
									for (var i = 0; i < a.length; i++) {
										if (a[i].store != null && a[i].store != "") {
											if (this.storeIds == '') {
												this.storeIds = a[i].store
											} else {
												this.storeIds = this.storeIds + ',' + a[i].store
											}
										}
									}
								} else {
									this.storeIds = a[0].store
								}
							}
							resolve()
						})
					}
				})
			},
			//
			getFranchiseesStore() {
				return new Promise((resolve) => {
					var b = {}
					b.storeIds = this.storeIds
					if (this.list.friendslist) {
						b.friendsStatus = this.list.friendslist
					}
					this.$http.get("store/getFranchiseesStore", {
						params: b
					}, {
						emulateJSON: true
					}).then(function(res) {
						if (res.body.code == "200") {
							this.tableData = res.body.data
						}
						resolve()
					})
				})
			},
			addfriend() {
				this.$router.push({
					path: '/newJoin'
				})
			},
			toggleSelection(rows) {
				if (rows) {
					rows.forEach(row => {
						this.$refs.multipleTable.toggleRowSelection(row);
					});
				} else {
					this.$refs.multipleTable.clearSelection();
				}
			},
			//筛选加盟商下拉框
			getFranchiseesStores() {
				this.$http.get("store/getFranchiseesList").then(res => {
					res.body.data.forEach(ele => {
						this.franchiseesStore.push(ele)
					})
				})
			},
			getStores() {
				this.$http.get("store/list").then(res => {
					res.body.data.forEach(ele => {
						if (ele.businessType === 1) {
							this.storesEnd.push(ele) //结业门店
						} else {
							this.stores.push(ele) //营业门店
						}
					})
				})
			},
			handleSelectionChange(val) {
				this.multipleSelection = val;
			},
			handleSizeChange(val) {
				console.log(`每页 ${val} 条`);
			},
			handleCurrentChange(val) {
				console.log(`当前页: ${val}`);
			},
		},
	};
</script>
<style lang="less" scoped>
	.first_line {
		margin: 10px 0px;
		display: flex;
		justify-content: space-between;

		.right_warp {
			display: flex;
			align-items: center;
			font-size: 16px;
			color: #3e3e3e;

			.el-select {
				width: 120px;
			}

			.el-input {
				width: 180px;

			}

			.jul {
				margin-left: 10px;
			}
		}

		.left_warp {
			display: flex;
			float: left;
			align-items: center;
			font-size: 16px;
			color: #3e3e3e;

			.el-select {
				width: 120px;
			}

			.el-input {
				width: 180px;
			}

			.jul {
				margin-left: 10px;
			}
		}
	}

	.pagescg {
		margin-top: 20px;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		align-items: center;
	}
</style>